import { render, staticRenderFns } from "./client.vue?vue&type=template&id=2fe6a6e3&scoped=true&"
import script from "./client.vue?vue&type=script&lang=js&"
export * from "./client.vue?vue&type=script&lang=js&"
import style0 from "./client.vue?vue&type=style&index=0&id=2fe6a6e3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe6a6e3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fe6a6e3')) {
      api.createRecord('2fe6a6e3', component.options)
    } else {
      api.reload('2fe6a6e3', component.options)
    }
    module.hot.accept("./client.vue?vue&type=template&id=2fe6a6e3&scoped=true&", function () {
      api.rerender('2fe6a6e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/settings/client.vue"
export default component.exports